import React from "react";
import HeroSection from "../components/home/HeroSection";
import FeaturesSection from "../components/home/FeaturesSection";
import StatsSection from "../components/home/StatsSection";
import ServicesPreview from "../components/home/ServicesPreview";
import CTASection from "../components/home/CTASection";
import LocationSection from "../components/home/LocationSection";

const Home = () => {
  const pageStyle = {
    paddingTop: "100px", // Account for fixed header
  };

  return (
    <div style={pageStyle}>
      <HeroSection />
      <LocationSection />
      <FeaturesSection />
      <StatsSection />
      <ServicesPreview />
      <CTASection />
    </div>
  );
};

export default Home;
